import { call, put } from 'redux-saga/effects';
import {
  addExcelTransactionsFailure,
  addExcelTransactionsSuccess,
  fetchAllExcelTransactionsRequest,
  fetchExcelFilesMetadataRequest,
} from '../actions';
import { addExcelTransactions } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { AddExcelTransactionsRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import { buildTransactionsRefreshFilters } from 'utils/entityTransactionsRequestFilters';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* addExcelTransactionsSaga(
  action: AddExcelTransactionsRequestAction
) {
  try {
    const { organisationId, body, refreshParams } = action.payload;

    const addResponse: ApiResponse = yield call(
      addExcelTransactions,
      organisationId,
      body
    );

    const err: ApiError | null = checkResponse(addResponse?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: String(i18n.t('common.success')),
      description: addResponse.responseMessage?.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(addExcelTransactionsSuccess());

    // Manual Entries file is created/updated on the backend — refresh file panel.
    yield put(fetchExcelFilesMetadataRequest(organisationId));

    if (refreshParams) {
      const refreshFilters = buildTransactionsRefreshFilters({
        tableFilters: refreshParams.filters,
        tabFileImportIds: refreshParams.tabFileImportIds,
      });
      yield put(
        fetchAllExcelTransactionsRequest(
          organisationId,
          refreshParams.page,
          refreshParams.pageSize,
          refreshFilters
        )
      );
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(addExcelTransactionsFailure());
  }
}
